const keys = {
  error: {
    entryContainsErrors: 'Oops! Looks like an answer is missing. Click "Edit" to fix it.',
    fourOfour: {
      headline: 'Ooops',
      title: 'Something Went Wrong.',
      subtitle: 'We cannot find the page you are looking for.',
    },
  },
};

export default keys;

export type TranslationKeys = typeof keys;
